module.exports = __webpack_public_path__ + "static/kanyon-e70a15b8423cff573a2e469a9a201902.jpg";